// molecule (단위 기능)

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역
// animation
import ShowNHide from 'src/com/keymansco/chihuahuaone/molecule/animation/ShowNHide/ShowNHide';

// =================================================================================================
// 상수
// =================================================================================================

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  animation: {
    // 애니메이션
    ShowNHide, // 스프링
  },
};
